export default [
  {
    path: '/crm/marketing',
    name: 'crm-marketing',
    component: () => import('@/views/crm/MarketingPage.vue'),
    meta: {
      pageTitle: 'CRM - Marketing',
      action: 'read',
      resource: 'MenuCrmMarketing',
      breadcrumb: [
        { text: 'CRM', active: false },
        { text: 'Marketing', active: true },
      ],
    },
  },
];
